import { Button, Col, Row, DatePicker, Table, Select, Popconfirm, message, Input } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import * as input from '../../Component/Layouts/FormInput.Style';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import {
  cancelPrescription,
  getPrescriptionBySearch,
  exportExcel,
  getSubAccount,
} from '../../Services/Prescription.service';
import { DataListType, StatusType } from './InterfaceType';

import { DownloadOutlined } from '@ant-design/icons';
import { statusLabel } from '../../Utils/config';
import ExternalLinkIcon from '../../Assets/Icons/ExternalLinkIcon';

const { Option } = Select;

type TablePaginationPosition = 'bottomCenter';
const PrescriptionList = () => {
  const [entities, setEntites] = useState<DataListType[]>([]);
  const [subAccount, setSubAccount] = useState<string[]>([]);
  const [bottom] = useState<TablePaginationPosition>('bottomCenter');
  const [isLoading, setIsLoading] = useState(false);
  const partnerCode = window.sessionStorage.getItem('partner_code');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(dayjs().add(-1, 'day').format('YYYY-MM-DD'));
  const [endDate, setEnddate] = useState<string>(dayjs().format('YYYY-MM-DD'));
  const [search, setSearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('ALL');
  const [selectedSubAccount, setSelectedSubAccount] = useState('ทั้งหมด');
  const formatTabelDate = 'YYYY-MM-DD';
  const [totalPages, setTotalPages] = useState();
  const Search = Input.Search;

  const prescriptList: ColumnsType<any> = [
    {
      title: 'เลขที่ใบสั่งแพทย์',
      dataIndex: 'prescript_no',
    },
    {
      title: 'วันที่บนใบสั่งแพทย์',
      dataIndex: 'prescript_date',
    },
    {
      title: 'วันที่ส่งใบสั่งแพทย์',
      dataIndex: 'submit_date',
    },
    {
      title: 'สมาชิก',
      dataIndex: 'full_name',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'phone_number',
    },
    {
      title: 'แพทย์ผู้วินิจฉัย',
      dataIndex: 'doctor_name',
    },
    {
      title: 'Partner',
      dataIndex: 'source',
    },
    {
      title: 'สถานะ',
      dataIndex: 'status_name',
    },
    {
      title: 'ติดตามขนส่ง',
      dataIndex: 'delivery_realtime_tracking',
      render: (delivery_realtime_tracking: any) => (
        <div>
          {delivery_realtime_tracking ? (
            <a href={delivery_realtime_tracking} target="_blank" rel="noopener noreferrer">
              <ExternalLinkIcon color="#00B3F0" />
            </a>
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      title: 'สถานะการสั่งซื้อ',
      dataIndex: 'order_status',
      render: (orderStatus: string) => orderStatusMap[orderStatus] || orderStatus || '-',
    },
    {
      title: 'clinic',
      dataIndex: 'sub_account',
    },
    {
      title: '',
      dataIndex: '',

      render: (item: DataListType) => (
        <div>
          {item.status === 'DRAFT' || item.status === 'REJECT' ? (
            <>
              <Link
                style={{ margin: '3px' }}
                to={{
                  pathname: `/PrescriptionForm/${item._id}`,
                }}
              >
                <Button
                  type="primary"
                  style={{
                    margin: '3px',
                    backgroundColor: '#FFB100',
                    width: '80px',
                  }}
                >
                  แก้ไข
                </Button>
              </Link>
              <Popconfirm
                placement="left"
                title={'ยืนยันการยกเลิกรายการนี้ใช่หรือไม่?'}
                onConfirm={() => onCancel(item._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="primary"
                  style={{
                    margin: '3px',
                    backgroundColor: '#F25F0A',
                    width: '80px',
                  }}
                >
                  ยกเลิก
                </Button>
              </Popconfirm>
            </>
          ) : (
            <Link
              style={{ margin: '3px' }}
              to={{
                pathname: `/PrescriptionForm/${item._id}`,
              }}
            >
              <Button
                type="primary"
                style={{
                  width: '80px',
                }}
              >
                ดูข้อมูล
              </Button>
            </Link>
          )}
        </div>
      ),
    },
  ];

  const onCancel = async (id: any) => {
    const update_by = window.sessionStorage.getItem('username') ?? '';
    const res = await cancelPrescription(id, update_by);
    if (res?.data.res_code === '000') {
      message.success('ยกเลิกสำเร็จ');
    }
    fetchData();
  };

  const statusOptions: StatusType[] = [
    { value: 'ALL', label: 'ทั้งหมด' },
    { value: 'INPROGRESS', label: 'กำลังดำเนินการ' },
    { value: 'WAITING', label: 'รอดำเนินการ' },
    { value: 'DRAFT', label: 'แบบร่าง' },
    { value: 'CANCEL', label: 'ยกเลิก' },
    { value: 'REJECT', label: 'ปฏิเสธ' },
    { value: 'CLOSED', label: 'สำเร็จ' },
  ];

  const itemList = selectedStatus === 'ALL' ? entities : entities.filter((item: any) => item.status === selectedStatus);
  const filteredSubAccountItemList =
    selectedSubAccount === 'ทั้งหมด'
      ? itemList
      : itemList.filter((item: any) => item.sub_account === selectedSubAccount);
  const onSearch = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    init();
    fetchData();
  }, [search, startDate, endDate, currentPage]);

  const init = async () => {
    const res = await getSubAccount();
    const listItem = ['ทั้งหมด', ...res.sub_account];
    setSubAccount(listItem);
  };
  const orderStatusMap = statusLabel.reduce(
    (acc, item) => {
      acc[item.code] = item.label;
      return acc;
    },
    {} as Record<string, string>,
  );

  const fetchData = async () => {
    const body = {
      page: currentPage,
      limit: 20,
      partner_code: partnerCode,
      start_prescript_date: startDate,
      end_prescript_date: endDate,
      search: search,
    } as any;
    if (selectedSubAccount !== 'ทั้งหมด') {
      body.sub_account = selectedSubAccount;
    }
    setIsLoading(true);
    const res = await getPrescriptionBySearch(body);
    const listItem = res?.datas?.entities;
    if (listItem) {
      listItem.forEach((item: any) => {
        item.prescript_date = dayjs(item.prescript_date).format('YYYY-MM-DD');
        item.submit_date = dayjs(item.created_date).format('YYYY-MM-DD');
        item.full_name = item.first_name + ' ' + item.last_name;
      });
    }
    setEntites(listItem);

    setIsLoading(false);
    setTotalPages(res?.datas?.page_info?.number_of_entities);
  };

  const onChangeStartDate = (date: any, dateString: string) => {
    setStartDate(dateString);
  };

  const onExportPrescription = async () => {
    const data = {
      page: currentPage,
      limit: entities.length,
      partner_code: partnerCode,
      start_prescript_date: startDate,
      end_prescript_date: endDate,
      search: search,
    };

    const res = await exportExcel(data);
    const presciptionList = res?.data.datas.entities;

    const exportItem: any[] = [];

    presciptionList.forEach((res: any) => {
      exportItem.push({
        created_date: dayjs(res.created_date).format('DD/MM/YYYY'),
        created_by: res.created_by,
        source: res.source,
        prescript_no: res.prescript_no,
        status: res.status,
        total_price: res.total_price || 0,
        total_discount: res.total_discount || 0,
        delivery_price: res.delivery_price,
        customer_name: res.first_name + ' ' + res.last_name,
        phone_number: res.phone_number,
        order_datetime: res.order_datetime ? dayjs(res.order_datetime).format('DD/MM/YYYY') : '-',
        pharmacist_login_name: res.pharmacist_login_name,
        order_id: res.order_id,
        Reserve_ID: res.Reserve_ID,
        pharmacist_delivery: res.pharmacist_delivery,
        site_desc: res.site_desc,
      });
    });

    // header
    const headers = [
      'วันที่สร้าง',
      'Username',
      'ชื่อ Partner',
      'เลขที่ใบสั่งแพทย์',
      'สถานะการสั่งซื้อ',
      'มูลค่าสินค้ารวม',
      'ส่วนลด',
      'ค่าส่ง',
      'ชื่อลูกค้า',
      'เบอร์โทรศัพท์',
      'วันที่อนุมัติ',
      'เภสัชกรที่อนุมัติ',
      'Order id',
      'Reserve id',
      'เภสัชกรจัดของ',
      'สาขาจัดส่ง',
    ];

    // build CSV
    const csvRows: string[] = [];

    // header row
    csvRows.push(headers.join(','));

    // data rows
    exportItem.forEach((item) => {
      const values = Object.values(item).map((val) => `"${String(val ?? '').replace(/"/g, '""')}"`);
      csvRows.push(values.join(','));
    });

    const csvString = csvRows.join('\n');

    // 🔥 สำคัญ: กันภาษาไทยเพี้ยนใน Excel
    const blob = new Blob(['\uFEFF' + csvString], {
      type: 'text/csv;charset=utf-8;',
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `รายงานจาก Medlink ${dayjs(new Date()).format('DD-MM-YYYY')}.csv`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={4}>
          <input.tittle>clinic</input.tittle>
          <Select
            value={selectedSubAccount}
            onChange={(key) => setSelectedSubAccount(key)}
            style={{
              border: 1,
              borderColor: '#0000',
              display: 'flex',
              width: 400,
            }}
          >
            {subAccount.map((status) => (
              <Option key={status} value={status}>
                {status}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={4}>
          <input.tittle>ค้นหา</input.tittle>
          <Search enterButton onSearch={onSearch} />
        </Col>
        <Col className="gutter-row" span={4}>
          <input.tittle>สถานะ</input.tittle>
          <Select
            value={selectedStatus}
            onChange={(key) => setSelectedStatus(key)}
            style={{
              border: 1,
              borderColor: '#0000',
              display: 'flex',
              width: 200,
            }}
          >
            {statusOptions.map((status) => (
              <Option key={status.value} value={status.value}>
                {status.label}
              </Option>
            ))}
          </Select>
        </Col>
        <Col className="gutter-row" span={4}>
          <input.tittle>เลือกวันที่เริ่มต้น</input.tittle>
          <DatePicker
            format={formatTabelDate}
            defaultValue={dayjs().add(-1, 'day')}
            style={{ display: 'flex', width: 180 }}
            onChange={(date, dateString) =>
              onChangeStartDate(date, Array.isArray(dateString) ? dateString[0] : dateString)
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <input.tittle>เลือกวันที่สิ้นสุด</input.tittle>
          <DatePicker
            format={formatTabelDate}
            defaultValue={dayjs()}
            style={{ display: 'flex', width: 180 }}
            onChange={(date, dateString) => setEnddate(Array.isArray(dateString) ? dateString[0] : dateString)}
          />
        </Col>
        <Col className="gutter-row" span={8}>
          <input.tittle style={{ color: 'white' }}>div</input.tittle>
          <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
            <a href="/PrescriptionForm/create">
              <Button
                type="primary"
                style={{
                  display: 'flex',
                  backgroundColor: '#78A500',
                  justifyContent: 'center',
                  margin: 3,
                }}
              >
                สร้างใบสั่งแพทย์
              </Button>
            </a>
            <Button style={{ margin: 3 }} icon={<DownloadOutlined />} type="primary" onClick={onExportPrescription}>
              Export
            </Button>
          </div>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={24} style={{ marginTop: 15 }}>
          <Table
            rowKey={(record: any) => record._id}
            bordered
            loading={isLoading}
            columns={prescriptList}
            dataSource={filteredSubAccountItemList}
            pagination={{
              total: totalPages,
              position: [bottom],
              pageSize: 20,
              onChange: (page: any) => {
                setCurrentPage(page);
              },
            }}
            scroll={{ y: 550, x: 550 }}
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default PrescriptionList;
